/**
 * Thin wrapper around the globally-loaded PostHog snippet
 * (installed by Emergent in /public/index.html).
 * All calls no-op safely if window.posthog isn't ready.
 */
const ph = () => (typeof window !== "undefined" ? window.posthog : null);

export const analytics = {
  identify(user) {
    const p = ph();
    if (!p || !user?.email) return;
    try {
      p.identify(user.user_id || user.email, {
        email: user.email,
        name: user.name,
        plan: user.plan,
        roles: user.roles,
      });
    } catch (e) { /* posthog stub not ready — ignore */ }
  },
  reset() {
    const p = ph();
    if (!p) return;
    try { p.reset(); } catch (e) { /* ignore */ }
  },
  track(event, props) {
    const p = ph();
    if (!p) return;
    try { p.capture(event, props || {}); } catch (e) { /* ignore */ }
  },
};

export default analytics;
